import { createSelector } from 'reselect';
export { showSuggestedProductsBeforeSFLSelectorFn, showSuggestedProductsAfterSFLSelectorFn } from './cart.selectors-other.utils';
const cartRootSelector = state => state.cart;
export const shouldShowWavedLoaderSelector = () => true;
export const resellersCommissionSelector = createSelector(cartRootSelector, state => state.resellersCommission);
export const productsCommissionSelector = createSelector(cartRootSelector, state => state.productsCommission);